import React, {forwardRef} from 'react'
import {AvatarGroupProps} from './types'
import {AvatarGroupBase, useUserProxies} from '.'

export const AvatarGroup = forwardRef(
  ({userIds, ...props}: AvatarGroupProps, ref) => {
    const users = useUserProxies(userIds)
    return users.length ? (
      <AvatarGroupBase ref={ref} {...props} users={users} />
    ) : null
  }
)
